import endpoints from '../../../config/endpoints';
import { suggestItemRender, labelItemRender } from './filter-country-render';
import { enum as conversionTypes } from '../../../../../enums/conversion-types';

export default [
	{
		title: 'Тип лида',
		suggest: [
			{
				placeholder: 'Выберите тип лида',
				key: 'lead_types',
				options: {
					source: [{
						id: conversionTypes.CPA,
						text: 'CPA'
					}, {
						id: conversionTypes.ApprovedRejected,
						text: 'Cancellations'
					}],
					type: 'fromSource'
				}
			}
		]
	},
	{
		title: 'Офферы',
		suggest: [
			{
				placeholder: 'Выберите оффер',
				key: 'offers',
				options: {
					source: endpoints.LOOKUPS.OFFERS,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Потоки',
		suggest: [
			{
				placeholder: 'Выберите поток',
				key: 'campaigns',
				options: {
					source: endpoints.STATISTICS.FILTERS.CAMPAIGNS,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Лендинги',
		suggest: [
			{
				placeholder: 'Выберите лендинг',
				key: 'landings',
				options: {
					source: endpoints.LOOKUPS.LANDINGS,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Транзитки',
		suggest: [
			{
				placeholder: 'Выберите транзитную страницу',
				key: 'transits',
				options: {
					source: endpoints.LOOKUPS.TRANSITS,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Источник трафика',
		suggest: [
			{
				placeholder: 'Выберите источник трафика',
				key: 'traffic_source',
				options: {
					source: endpoints.STATISTICS.FILTERS.TRAFFIC_SOURCES,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Страны',
		customRender: {
			label: labelItemRender,
			suggest: suggestItemRender
		},
		suggest: [
			{
				placeholder: 'Выберите страну',
				key: 'countries',
				options: {
					source: endpoints.LOOKUPS.COUNTRIES,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'SubID',
		suggest: [
			{
				placeholder: 'SID1',
				key: 'sids1',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID1,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID2',
				key: 'sids2',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID2,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID3',
				key: 'sids3',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID3,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID4',
				key: 'sids4',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID4,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID5',
				key: 'sids5',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID5,
					type: 'fromServer'
				}
			}
		]
	},
	{
		title: 'Трафик',
		suggest: [
			{
				placeholder: 'Выберите тип траффика',
				key: 'traffic_types',
				options: {
					source: 'app.lists.traffic-types',
					type: 'fromState'
				}
			}
		]
	},
	{
		title: 'Модель продаж',
		suggest: [
			{
				placeholder: 'Выберите модель продаж',
				key: 'sale_model',
				options: {
					source: 'app.lists.offer-sale-models',
					type: 'fromState'
				}
			}
		]
	},
	{
		title: 'Тип потока',
		suggest: [
			{
				placeholder: 'Выберите тип потока',
				key: 'campaign_types',
				options: {
					source: 'app.lists.campaign-types',
					type: 'fromState'
				}
			}
		]
	},
	{
		title: 'Дата смены статуса',
		suggest: [
			{
				placeholder: 'Выберите дату смены статуса',
				key: 'status_changed_at',
				options: {
					source: endpoints.LOOKUPS.STATUS_CHANGED_AT,
					type: 'fromServer'
				}
			}
		]
	}
];



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/shared/filter-config.js